import React, { useEffect } from "react";
import TopBanner from "../components/TopBanner";
import { ContentWrapper } from "./InsuranceGuidance";
import styled from "styled-components";

const Disclaimer = () => {
  useEffect(() => {
    document.title = "Disclaimer – Wealthies Insurance Guidance Platform";
  }, []);

  return (
    <>
      <TopBanner content={"Disclaimer"} />

      <ContentWrapper>
        <div className="text-content">
          <h2>Disclaimer</h2>

          <h3>
            <span>Research & Awareness</span> Disclaimer
          </h3>
          <p>
            Wealthies is operated by Shreeman Assure Services Pvt Ltd, which is
            engaged in marketing, research, and customer engagement services.
          </p>
          <p>
            The platform may conduct general research, analysis, and content
            development related to insurance products, market trends, and
            consumer awareness.
          </p>
          <p>
            All such research and content are intended solely for informational
            and educational purposes. This information should not be interpreted
            as professional advice, recommendations, endorsements, or
            solicitation to purchase any specific insurance product or service.
          </p>

          <h3>
            Nature <span>of</span> Platform
          </h3>
          <p>
            Wealthies operates as an insurance awareness, research, and customer
            connection platform.
          </p>
          <p>
            The platform is designed to simplify insurance-related concepts and
            facilitate interactions between individuals and licensed insurance
            professionals.
          </p>

          <h3>
            No <span>Insurance</span> Advisory
          </h3>
          <p>
            Wealthies does not provide insurance advisory, financial advisory,
            or investment advisory services.
          </p>
          <p>
            Any information, content, or material available on the platform
            should not be considered as advice or recommendation to purchase,
            modify, or cancel any insurance policy.
          </p>
          <p>
            Users are encouraged to consult licensed insurance professionals
            before making any decisions.
          </p>

          <h3>
            No <span>Sale or Distribution</span> of Insurance
          </h3>
          <p>
            Wealthies does not sell, distribute, or underwrite insurance
            policies.
          </p>
          <p>
            Insurance products are offered and serviced solely by licensed
            insurance agents and insurers in accordance with applicable
            regulatory guidelines.
          </p>

          <h3>Platform Role</h3>
          <p>
            Wealthies acts as a marketing, research, and customer connection
            platform.
          </p>
          <p>
            The platform may facilitate communication between individuals and
            licensed insurance professionals but does not participate in policy
            issuance, underwriting, or claim settlement.
          </p>

          <h3>
            No <span>Guarantee</span> of Outcomes
          </h3>
          <ul>
            <li>Approval of insurance policies</li>
            <li>Claim settlement outcomes</li>
            <li>Suitability of any insurance product</li>
            <li>Financial returns or benefits</li>
            <li>Accuracy of premium or coverage estimates</li>
          </ul>
          <p>
            All decisions related to insurance policies are made by insurers and
            licensed professionals.
          </p>

          <h3>
            <span>Wealthies</span> Shield
          </h3>
          <p>
            Wealthies Shield is a guidance support initiative that helps users
            understand insurance-related processes such as claims, renewals, and
            documentation.
          </p>
          <p>
            Wealthies does not process, approve, or influence insurance claims
            and does not act on behalf of any insurer.
          </p>

          <h3>
            <span>Calculators & Tools</span> Disclaimer
          </h3>
          <p>
            Any calculators, estimators, or tools provided on the platform are
            based on general assumptions and standard financial principles.
          </p>
          <p>
            The results generated are indicative and for educational purposes
            only. Actual insurance needs, premiums, and coverage may vary.
          </p>

          <h3>
            <span>Blog & Educational</span> Content
          </h3>
          <p>
            Content available in blogs, guides, and knowledge sections is
            intended for general awareness and simplified understanding.
          </p>
          <p>
            Such content may not cover all policy details, exclusions, or
            regulatory updates and should not be treated as professional advice.
          </p>

          <h3>
            <span>Accuracy</span> of Information
          </h3>
          <p>
            While reasonable efforts are made to ensure the accuracy of
            information, Wealthies does not guarantee completeness, reliability,
            or accuracy at all times.
          </p>
          <p>
            Insurance regulations, tax laws, and policy terms may change
            periodically.
          </p>

          <h3>
            <span>Third-Party</span> Interaction
          </h3>
          <p>
            Users may interact with licensed insurance professionals through the
            platform.
          </p>
          <p>
            Wealthies is not responsible for the services, advice, actions, or
            conduct of any third-party insurance professional.
          </p>

          <h3>
            <span>No Cost</span> for Users
          </h3>
          <p>
            Wealthies does not charge individuals for accessing insurance
            awareness content or submitting requests for guidance.
          </p>
          <p>
            The platform operates on a service-based model where fees may be
            applicable to advisors for platform-related services.
          </p>

          <h3>
            <span>Regulatory</span> Position
          </h3>
          <p>
            Wealthies operates as a marketing and research service provider.
          </p>
          <p>
            The platform does not function as an insurance intermediary, broker,
            insurer, or agent under applicable laws and regulations.
          </p>

          <h3>
            <span>Limitation</span> of Liability
          </h3>
          <p>
            Wealthies shall not be liable for any direct, indirect, incidental,
            or consequential loss, damage, or financial decisions arising from
            the use of the platform or reliance on any information provided.
          </p>

          <h3>
            <span>Changes</span> to Disclaimer
          </h3>
          <p>
            Wealthies reserves the right to update, modify, or revise this
            Disclaimer at any time without prior notice.
          </p>

          <h3>
            <span>Contact</span> Information
          </h3>
          <p>
            Shreeman Assure Services Pvt Ltd
            <br />
            Bangalore, India
            <br />
            <Text>
              <a href="mailto:contact@wealthies.in">
                Email: contact@wealthies.in
              </a>
            </Text>
          </p>

          <hr />

          <h2 style={{ marginBottom: "30px" }}>Advisor Disclaimer</h2>

          <h3>
            <span>Platform</span> Role
          </h3>
          <p>
            Wealthies provides a platform for marketing, research, and
            facilitating connections between individuals and licensed insurance
            professionals.
          </p>
          <p>
            Wealthies does not act as an insurer, broker, employer, or partner
            of advisors.
          </p>

          <h3>
            <span>No Guarantee</span> of Leads or Conversions
          </h3>
          <ul>
            <li>Number of leads</li>
            <li>Quality or accuracy of leads</li>
            <li>Customer intent or readiness</li>
            <li>Conversions or sales outcomes</li>
          </ul>

          <h3>
            <span>No Assurance</span> of Business or Income
          </h3>
          <ul>
            <li>Fixed business volume</li>
            <li>Guaranteed income</li>
            <li>Return on investment</li>
          </ul>

          <h3>
            <span>Nature</span> of Leads
          </h3>
          <p>Leads or inquiries are based on user-submitted information.</p>
          <p>
            Wealthies does not guarantee exclusivity, accuracy, or completeness
            of such information.
          </p>

          <h3>
            <span>Advisor</span> Responsibility
          </h3>
          <ul>
            <li>Communication with customers</li>
            <li>Compliance with applicable laws and regulations</li>
            <li>Services and information provided to customers</li>
          </ul>

          <h3>
            <span>Compliance</span> Requirement
          </h3>
          <p>
            Advisors must hold valid licenses as per IRDAI guidelines and comply
            with all applicable regulatory requirements.
          </p>

          <h3>
            <span>Fees</span> and Payments
          </h3>
          <p>Platform or service fees may be applicable for advisors.</p>
          <p>All payments are governed by the Wealthies Refund Policy.</p>
          <p>Applicable taxes, including GST, are non-refundable.</p>

          <h3>
            <span>No Refund</span> for Performance
          </h3>
          <ul>
            <li>Lack of conversions</li>
            <li>Dissatisfaction with leads</li>
            <li>Business performance</li>
          </ul>

          <h3>
            <span>Customer</span> Interaction Risk
          </h3>
          <p>Customer decisions are independent and may vary.</p>

          <h3>
            <span>Limitation</span> of Liability
          </h3>
          <ul>
            <li>Business losses</li>
            <li>Unsuccessful conversions</li>
            <li>Disputes between advisors and customers</li>
          </ul>

          <h3>
            <span>Platform</span> Misuse
          </h3>
          <p>
            Any misuse of the platform, including non-compliance or unethical
            practices, may result in suspension or termination without notice.
          </p>
        </div>
      </ContentWrapper>
    </>
  );
};

export const Text = styled.p`
  margin: 0 0 10px;
  line-height: 1.6;
  a {
    color: #333;
    text-decoration: none;
  }
`;
export default Disclaimer;
